import { useMemo } from "react";

import { AutoComplete } from "@/components/AutoCompleteInput";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useAllReleaseLabels } from "@/queries";

interface LabelMultiSelectProps {
  selectedLabels: string[];
  onChange: (labels: string[]) => void;
  promptId?: number;
}

const LabelMultiSelect = ({ selectedLabels, onChange, promptId }: LabelMultiSelectProps) => {
  const userToken = useAuth()?.userToken ?? "";
  const workspaceId = useUser()?.activeWorkspaceId ?? 0;

  const { data, isLoading } = useAllReleaseLabels(userToken, workspaceId);

  const labelOptions = useMemo(() => {
    const labels = data?.available_prompt_label_names ?? [];
    return [...labels].sort().map(label => ({
      id: label,
      value: label,
      label,
    }));
  }, [data?.available_prompt_label_names]);

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-gray-700">Release label{promptId ? "" : "s"}</p>
      <AutoComplete
        size="small"
        multi
        options={labelOptions}
        selectedValues={selectedLabels}
        onSelectionChange={onChange}
        placeholder={isLoading ? "Loading labels..." : "Add label"}
        addNewOption
        getAddOptionText={query => `Add "${query}"`}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LabelMultiSelect;
